export default {
  CONFIRM: 'confirm',
  CHANGE: 'change',
};
